import { PAGES } from "../content/pages";
import { useSite } from "../context/SiteContext";
import { Seo } from "../components/site/Seo";
import { PageHeader } from "../components/site/PageHeader";
import { RichText } from "../components/site/RichText";
import { AsideCta } from "../components/site/AsideCta";
import { ServiceGrid } from "../components/site/ServiceCard";
import { SectionTitle } from "../components/site/SectionTitle";
import { CampaignBanner } from "../components/site/CampaignBanner";
import { ContactSection } from "../components/site/ContactSection";
import { WhySection } from "../components/site/WhySection";

const Sections = ({ sections }) =>
  sections.map((s, i) => (
    <section key={s.h2} className={i > 0 ? "mt-14 border-t border-gold/15 pt-12" : ""} data-testid={`seo-section-${i}`}>
      <h2 className="mb-6 text-2xl font-semibold leading-tight text-emerald-950 sm:text-3xl">{s.h2}</h2>
      <RichText text={s.body} />
    </section>
  ));

export default function SeoPage({ pageKey }) {
  const p = PAGES[pageKey];
  const { services } = useSite();
  const crumbs = [{ to: "/", label: "Ana Sayfa" }, { to: p.path, label: p.h1 }];
  return (
    <>
      <Seo title={p.title} description={p.description} path={p.path} image={p.image} breadcrumbs={crumbs} />
      <PageHeader eyebrow={p.eyebrow} h1={p.h1} intro={p.intro} image={p.image} imageAlt={p.imageAlt} crumbs={crumbs} />
      <div className="container-lux grid gap-12 py-16 lg:grid-cols-[minmax(0,1fr)_340px] lg:gap-16 lg:py-24">
        <article className="min-w-0" data-testid="seo-article">
          <Sections sections={p.sections} />
        </article>
        <AsideCta current={p.path} />
      </div>
      {p.showServices && (
        <section className="bg-cream-grad py-20 lg:py-24" data-testid="seo-services">
          <div className="container-lux">
            <SectionTitle eyebrow="Hizmetler" title={pageKey === "masaj-hizmetleri" ? "Tüm Masaj ve Spa Hizmetlerimiz" : "Lunessa’da Sunduğumuz Hizmetler"} sub="Kendinize zaman ayırın, Lunessa’nın rahatlatıcı masaj deneyimiyle yenilenin." />
            <ServiceGrid services={pageKey === "masaj-hizmetleri" ? services : services.slice(0, 6)} />
          </div>
        </section>
      )}
      {p.afterSections && (
        <div className="container-lux max-w-4xl py-16 lg:py-20">
          <Sections sections={p.afterSections} />
        </div>
      )}
      {pageKey === "hakkimizda" && <WhySection />}
      <CampaignBanner />
      <ContactSection />
    </>
  );
}
